import { canAccessApp, isStaffUser } from '@apexx/auth';

/** Hub launcher app access metadata shared between the shell and embedded sub-apps. */
export const HUB_APP_ACCESS = [
	{ id: 'machines', requiredRole: 'app:machines' },
	{ id: 'quality', requiredRole: 'app:quality', staffOnly: true },
	{ id: 'chat', requiredRole: 'app:chat' },
	{ id: 'documents', requiredRole: 'app:documents' },
	{ id: 'tasks', requiredRole: 'app:tasks' },
	{ id: 'training', requiredRole: 'app:training' },
] as const;

export type HubAppId = (typeof HUB_APP_ACCESS)[number]['id'];

/** Returns hub app ids the token may launch (matches hub launcher filtering). */
export function getAccessibleHubAppIds(accessToken?: string): HubAppId[] {
	return HUB_APP_ACCESS.filter((app) => {
		if (!canAccessApp(accessToken, app.requiredRole)) {
			return false;
		}

		if ('staffOnly' in app && app.staffOnly && !isStaffUser(accessToken)) {
			return false;
		}

		return true;
	}).map((app) => app.id);
}

/**
 * True when embedded sub-apps should show an app switcher back to the launcher.
 * Staff always; clients only when they have access to more than one hub app.
 */
export function canSwitchHubApps(accessToken?: string): boolean {
	return isStaffUser(accessToken) || getAccessibleHubAppIds(accessToken).length > 1;
}
